export default {
  defaultProps: {
    variant: 'outlined' as const,
    fullWidth: true,
  },
};
